import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "./Icon";
import { useAuth } from "../contexts/AuthContext";

const ITEMS_BY_ROLE = {
  admin: [
    { group: "Pages", icon: "dashboard", label: "Dashboard", to: "/admin" },
    { group: "Pages", icon: "users", label: "Clients", to: "/admin/clients" },
    { group: "Pages", icon: "check-square", label: "Task Oversight", to: "/admin/oversight" },
    { group: "Pages", icon: "layers", label: "Task Masters", to: "/admin/task-masters" },
    { group: "Pages", icon: "folder", label: "Task Groups", to: "/admin/task-groups" },
    { group: "Pages", icon: "message-circle", label: "Tickets", to: "/admin/tickets" },
    { group: "Pages", icon: "message-circle", label: "Chat", to: "/admin/chat", requireAddon: ["chat", "chat_extended"] },
    { group: "Pages", icon: "folder", label: "Drive", to: "/admin/drive" },
    { group: "Pages", icon: "user", label: "Employees", to: "/admin/employees" },
    { group: "Pages", icon: "briefcase", label: "Departments", to: "/admin/departments" },
    { group: "Pages", icon: "map-pin", label: "Geofences", to: "/admin/geofences", requireAddon: ["geofence"] },
    { group: "Pages", icon: "clock", label: "Attendance Register", to: "/admin/attendance", requireAddon: ["attendance"] },
    { group: "Pages", icon: "file-text", label: "Attendance Reports", to: "/admin/attendance/reports", requireAddon: ["attendance"] },
    { group: "Pages", icon: "settings", label: "Attendance Settings", to: "/admin/attendance/settings", requireAddon: ["attendance"] },
    { group: "Pages", icon: "calendar", label: "Leaves", to: "/admin/leaves", requireAddon: ["attendance"] },
    { group: "Pages", icon: "check-circle", label: "My Attendance", to: "/admin/my-attendance", requireAddon: ["attendance"] },
    { group: "Pages", icon: "calendar", label: "My Leaves", to: "/admin/my-leaves", requireAddon: ["attendance"] },
    { group: "Pages", icon: "zap", label: "Ops Runner", to: "/admin/ops" },
    { group: "Pages", icon: "receipt", label: "Payments Oversight", to: "/admin/payments" },
    { group: "Pages", icon: "dollar-sign", label: "Payment Templates", to: "/admin/payments/masters" },
    { group: "Pages", icon: "hard-drive", label: "Server", to: "/admin/server" },
    { group: "Pages", icon: "folder", label: "Org Drive", to: "/admin/org-kb/drive" },
    { group: "Pages", icon: "lock", label: "Org Fields", to: "/admin/org-kb/fields" },
    { group: "Pages", icon: "calendar", label: "Calendar", to: "/admin/calendar" },
  ],
  employee: [
    { group: "Pages", icon: "check-square", label: "My Tasks", to: "/me" },
    { group: "Pages", icon: "calendar", label: "Calendar", to: "/me/calendar" },
    { group: "Pages", icon: "clock", label: "History", to: "/me/history" },
    { group: "Pages", icon: "message-circle", label: "Assigned Tickets", to: "/me/tickets" },
    { group: "Pages", icon: "message-circle", label: "Chat", to: "/me/chat", requireAddon: ["chat", "chat_extended"] },
    { group: "Pages", icon: "check-circle", label: "My Attendance", to: "/me/attendance", requireAddon: ["attendance"] },
    { group: "Pages", icon: "calendar", label: "My Leaves", to: "/me/leaves", requireAddon: ["attendance"] },
    { group: "Pages", icon: "folder", label: "Org Drive", to: "/me/org-kb/drive" },
    { group: "Pages", icon: "lock", label: "Org Fields", to: "/me/org-kb/fields" },
  ],
  customer: [
    { group: "Pages", icon: "home", label: "Overview", to: "/portal" },
    { group: "Pages", icon: "message-circle", label: "Tickets", to: "/portal/tickets" },
    { group: "Pages", icon: "folder", label: "Documents", to: "/portal/files" },
  ],
};

export default function CmdK({ open, onClose, role }) {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { hasAddon } = useAuth();

  useEffect(() => {
    if (!open) setQ("");
  }, [open]);

  if (!open) return null;
  // Drop addon-gated pages (e.g. Chat) when the firm doesn't have the addon.
  const items = (ITEMS_BY_ROLE[role] || []).filter(
    (it) => !it.requireAddon || hasAddon(...it.requireAddon),
  );
  const filtered = q ? items.filter((it) => it.label.toLowerCase().includes(q.toLowerCase())) : items;
  const groups = filtered.reduce((acc, it) => {
    (acc[it.group] = acc[it.group] || []).push(it);
    return acc;
  }, {});

  const go = (to) => {
    navigate(to);
    onClose();
  };

  return (
    <div className="cmdk-backdrop" onClick={onClose}>
      <div className="cmdk" onClick={(e) => e.stopPropagation()}>
        <input
          autoFocus
          className="cmdk-input"
          placeholder="Search pages…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <div className="cmdk-results">
          {Object.entries(groups).map(([g, list]) => (
            <div key={g}>
              <div className="cmdk-group">{g}</div>
              {list.map((it) => (
                <div key={it.to} className="cmdk-item" onClick={() => go(it.to)}>
                  <span className="cmdk-item-icon">
                    <Icon name={it.icon} size={14} />
                  </span>
                  <span style={{ flex: 1 }}>{it.label}</span>
                  <span style={{ fontSize: 11, color: "var(--ink-400)" }}>↵</span>
                </div>
              ))}
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ padding: 24, textAlign: "center", color: "var(--ink-500)" }}>No matches</div>
          )}
        </div>
      </div>
    </div>
  );
}
